// The operator app's OWN coupon, read straight out of its redux store.
//
// ⛔ WHY THIS EXISTS (measured on the box 2026-09-12). Every add since ~01:22 came
// back `rejected posted=N landed=0` with `add_ack: "timeout"` — NO betting message
// arrived at all, and the legs never landed in the 15s late window either. The app
// itself was fine: the same account placed bets at 02:52, 02:54, 02:56. So our
// verdict was a statement about a MISSING MESSAGE, not about the coupon, and the
// card told the user «не удалось добавить» over a slip the app may well have filled.
//
// The app keeps the coupon in its own store — `common.betslip.CheckedStakesList`
// (verified in Digitain's own bundle, 8.0.26253.3) — and on a NATIVE operator that
// store is in OUR document, exactly like `eventDetails` that `open-match-net.ts`
// already reads. Reading it makes the add verdict independent of the bus.
//
// ⛔ FAILS CLOSED. A missing store, a reshaped slice or a throw returns `null` —
// "we cannot see it" — never `[]`, which would read as "the user holds nothing".
// The bus remains the primary source; this is a second reading of the same truth.

export interface StoreCouponLeg {
  stakeId: number;
  eventId: number | null;
  /** The book accepted the stake and immediately killed it — present on screen,
   *  impossible to place. Kept because it is a REAL answer about that id. */
  deleted: boolean;
}

/** Every leg the app's own store says is in the coupon, or null when the store
 *  cannot be read. */
export function storeCoupon(win: unknown): StoreCouponLeg[] | null {
  try {
    const w = win as
      | { sportdigi?: { mobile?: { store?: { getState?: () => unknown } } } }
      | null;
    const state = w?.sportdigi?.mobile?.store?.getState?.() as
      | { common?: { betslip?: { CheckedStakesList?: unknown } } }
      | undefined;
    const list = state?.common?.betslip?.CheckedStakesList;
    if (!Array.isArray(list)) return null;
    const out: StoreCouponLeg[] = [];
    for (const raw of list) {
      const s = raw as { StakeId?: unknown; EventId?: unknown; Deleted?: unknown } | null;
      const stakeId = Number(s?.StakeId);
      if (!Number.isFinite(stakeId) || stakeId <= 0) continue;
      const eventId = Number(s?.EventId);
      out.push({
        stakeId,
        eventId: Number.isFinite(eventId) && eventId > 0 ? eventId : null,
        deleted: s?.Deleted === true,
      });
    }
    return out;
  } catch {
    return null;
  }
}

/** The coupon as stake ids — dead legs excluded, because a dead leg is not a leg
 *  the user can place, and counting one would flip a card to "in betslip" over a
 *  row the app has already greyed. `null` when the store cannot be read. */
export function storeCouponStakeIds(win: unknown): number[] | null {
  const coupon = storeCoupon(win);
  return coupon ? coupon.filter((l) => !l.deleted).map((l) => l.stakeId) : null;
}

/** Observe the same native coupon we read, without polling or changing it.
 * Missing/reshaped stores keep the bus and existing deadline as fallbacks. */
export function subscribeStoreCoupon(win: unknown, notify: () => void): () => void {
  try {
    const store = (win as { sportdigi?: { mobile?: { store?: {
      subscribe?: (fn: () => void) => unknown;
    } } } } | null)?.sportdigi?.mobile?.store;
    const unsubscribe = store?.subscribe?.(notify);
    if (typeof unsubscribe !== "function") return () => {};
    let active = true;
    return () => {
      if (!active) return;
      active = false;
      try { unsubscribe(); } catch { /* a reshaped store cannot break settlement */ }
    };
  } catch {
    return () => {};
  }
}
